import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "hidden md:block mt-12 text-2xl font-bold" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex gap-1 mt-4" }
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = { class: "flex items-end mt-4" }
const _hoisted_9 = { class: "text-xl italic" }
const _hoisted_10 = { class: "text-sm font-light mt-2 h-8" }
const _hoisted_11 = { class: "flex gap-1 items-center mt-2" }
const _hoisted_12 = { class: "bg-gray-200 px-2 py-1 text-xs uppercase rounded-sm" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4 text-green-600"
}
const _hoisted_14 = {
  key: 1,
  class: "mt-4 text-green-600"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: $props.category.id,
    id: 'category-' + $props.category.id,
    class: "scroll-mt-48 px-4"
  }, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString($props.category.name), 1 /* TEXT */),
    _createElementVNode("div", {
      class: _normalizeClass(["md:grid gap-8 gap-y-12", $props.category.name == 'Boots' ? 'grid-cols-2' : 'grid-cols-4'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (product, idx) => {
        return (_openBlock(), _createElementBlock("article", {
          id: product.name
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createCommentVNode(" Image "),
              _createElementVNode("img", {
                src: $options.rotateImage(product),
                class: "h-96 w-full object-cover rounded-md"
              }, null, 8 /* PROPS */, _hoisted_5),
              _createCommentVNode(" variants options "),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.variants, (variant) => {
                  return (_openBlock(), _createElementBlock("button", {
                    onMouseover: $event => ($options.changeVariant(idx, variant)),
                    type: "button",
                    class: "size-5 bg-gray-100 p-1 border border-black rounded-full btn",
                    style: _normalizeStyle('background-color:' + variant.code)
                  }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_7))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString($data.isMobile ? $props.category.name : product.name), 1 /* TEXT */)
              ]),
              _createCommentVNode(" Description "),
              _createElementVNode("div", _hoisted_10, _toDisplayString(product.description), 1 /* TEXT */),
              _createCommentVNode(" sizes options "),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.sizes, (sizes) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(sizes), 1 /* TEXT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _createCommentVNode(" price "),
              (!product.price)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Request a quote "))
                : _createCommentVNode("v-if", true),
              (product.price)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(product.price), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: $event => ($options.addToCart(product)),
                class: "btn btn-secondary mt-2 w-full mb-4"
              }, [
                ($data.loading == product.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createCommentVNode(" loading spinner "),
                      _cache[0] || (_cache[0] = _createElementVNode("svg", {
                        class: "mx-auto size-6 animate-spin text-wm-blue",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1 /* CACHED */))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, " Add to Cart "))
              ], 8 /* PROPS */, _hoisted_15)
            ])
          ])
        ], 8 /* PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}